import script from "./RegisterConfirmPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterConfirmPage.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterConfirmPage.vue?vue&type=style&index=0&id=2fab46ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fab46ec"]])

export default __exports__